var React = require('react');

function StatusLoading (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"280","height":"153","rx":"24","fill":"white","fillOpacity":"0.05","key":0}),React.createElement("rect",{"x":"24","y":"24","width":"181","height":"27","rx":"13.5","fill":"white","fillOpacity":"0.1","key":1}),React.createElement("rect",{"x":"24","y":"67","width":"232","height":"62","rx":"31","fill":"white","fillOpacity":"0.1","key":2})]);
}

StatusLoading.defaultProps = {"width":"280","height":"153","viewBox":"0 0 280 153","fill":"none"};

module.exports = StatusLoading;

StatusLoading.default = StatusLoading;
